import React from 'react';
import { CHECKOUT_URL } from '../data/checkout';
import { ORDEN_FINANCIERO_CONTENT, trackEventDeduped } from '../utils/pixel';
interface ButtonProps {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  fullWidth?: boolean;
  className?: string;
}
export function Button({
  children,
  href,
  onClick,
  fullWidth,
  className = ''
}: ButtonProps) {
  const baseClasses = `inline-flex items-center justify-center text-center px-6 md:px-8 py-4 text-base font-semibold text-white bg-teal-600 rounded-lg hover:bg-teal-700 transition-colors duration-200 shadow-lg hover:shadow-xl ${fullWidth ? 'w-full' : ''} ${className}`;
  const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!href) return;
    // Checkout CTA: fire InitiateCheckout, then let the redirect happen
    if (isCheckoutLink(href)) {
      trackEventDeduped('InitiateCheckout', ORDEN_FINANCIERO_CONTENT, 'InitiateCheckout');
      return;
    }
    if (!href.startsWith('#')) return;
    e.preventDefault();
    const id = href.slice(1);
    const target = document.getElementById(id);
    if (!target) return;
    const rect = target.getBoundingClientRect();
    window.scrollTo({
      top: window.scrollY + rect.top - 12,
      behavior: 'smooth'
    });
  };
  if (href) {
    // Check if it's an external link (starts with http)
    const isExternal = href.startsWith('http');
    return <a href={href} className={baseClasses} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} onClick={handleAnchorClick} data-id="element-41" data-mp="3qfk6l0ohmwip">
        {children}
      </a>;
  }
  return <button onClick={onClick} className={baseClasses} data-id="element-42" data-mp="3lh0lf2hpxore">
      {children}
    </button>;
}
function isCheckoutLink(href: string) {
  return href.startsWith(CHECKOUT_URL) || /\/checkout/i.test(href);
}